import React, { useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../../../../../context/AuthContext';
import styles from './UserProfileDropdown.module.css';

const UserProfileDropdown = () => {
    const { user, logout } = useContext(AuthContext);
    const navigate = useNavigate();

    const handleLogout = () => {
        logout();
        navigate('/');
    };

    const getDashboardLink = () => {
        return user?.userType === 'fan' ? '/fan-dashboard' : '/dashboard';
    };

    const getProfileLink = () => {
        return user?.userType === 'fan' ? '/profile2' : '/profile';
    };

    return (
        <div className={styles.userProfileDropdown}>
            <div className={styles.dropdownContainer}>
                <button
                    className={styles.profileButton}
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                >
                    <div className={styles.avatarContainer}>
                        <img
                            src={user?.profilepicture || 'https://c.animaapp.com/mhof1dcsmYxOSQ/assets/icon-6.svg'}
                            alt="User Profile"
                            className={styles.avatar}
                            onError={(e) => {
                                e.target.src = 'https://c.animaapp.com/mhof1dcsmYxOSQ/assets/icon-6.svg';
                            }}
                        />
                    </div>
                    <span className={styles.userName}>
                        {user?.fullName || 'User'}
                    </span>
                </button>

                <div className={`dropdown-menu ${styles.dropdownMenu}`}>
                    <div className={styles.userHeader}>
                        <div className={styles.userAvatar}>
                            <img
                                src={user?.profilepicture || 'https://c.animaapp.com/mhof1dcsmYxOSQ/assets/icon-6.svg'}
                                alt="User"
                                className={styles.avatarImg}
                                onError={(e) => {
                                    e.target.src = 'https://c.animaapp.com/mhof1dcsmYxOSQ/assets/icon-6.svg';
                                }}
                            />
                        </div>
                        <div className={styles.userText}>
                            <h6>{user?.fullName || 'User'}</h6>
                            <p className={styles.userType}>
                                {user?.userType === 'fan' ? 'Fan' : 'Celebrity'}
                            </p>
                        </div>
                    </div>

                    <div className="dropdown-divider"></div>

                    <Link
                        className={`dropdown-item ${styles.dropdownItem}`}
                        to={getDashboardLink()}
                    >
                        <i className="isax isax-chart-square me-2"></i>
                        Dashboard
                    </Link>

                    <Link
                        className={`dropdown-item ${styles.dropdownItem}`}
                        to={getProfileLink()}
                    >
                        <i className="isax isax-user-edit me-2"></i>
                        Profile Settings
                    </Link>

                    <div className="dropdown-divider"></div>

                    <button
                        className={`dropdown-item ${styles.dropdownItem} ${styles.logoutItem}`}
                        onClick={handleLogout}
                    >
                        <i className="isax isax-logout me-2"></i>
                        Logout
                    </button>
                </div>
            </div>
        </div>
    );
};

export default UserProfileDropdown;